// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { PaymentProviderOperationsService } from '../generated/api/paymentProviderOperations.service';

@Injectable({ providedIn: 'root' })
export class PaymentProviderOperationsClientService {
  constructor(private readonly client: PaymentProviderOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    failureStartUnixMilliseconds?: number,
    failureEndUnixMilliseconds?: number,
    failurePage?: number,
    failurePageSize?: number,
    planChangePage?: number,
    planChangePageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ProviderOperationsSnapshotResponse> {
    if (!this.client)
      throw new Error('PaymentProviderOperationsService is not available');
    return this.client.paymentProviderOperationsGet(
      failureStartUnixMilliseconds,
      failureEndUnixMilliseconds,
      failurePage,
      failurePageSize,
      planChangePage,
      planChangePageSize,
      'body',
      reportProgress,
      options,
    );
  }

  setControl(
    providerKey: string,
    request: WrapperApi.ProviderOperationalControlRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ProviderOperationalControlResponse> {
    if (!this.client)
      throw new Error('PaymentProviderOperationsService is not available');
    return this.client.paymentProviderOperationsSetControl(
      providerKey,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
